import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { Alert } from '../../misc/interfaces';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertComponent implements OnInit {

  staticAlertClosed = false;

  @ViewChild('selfClosingAlert', {static: false}) selfClosingAlert!: NgbAlert;
  @Input() alert!: Alert;
  constructor(public activeModal: NgbActiveModal) { }


  ngOnInit(): void {

    setTimeout(() => {

      this.selfClosingAlert.close();
      this.activeModal.close();

    }, 2000);

  }

  close(): void {
    this.activeModal.close();
  }


}
